var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-header" },
    _vm._l(_vm.parsedConfig, function(element) {
      return _c(
        "div",
        {
          key: element.field,
          class: _vm.getTableHeaderCellClass(element.sortable),
          style: element.columnWidth,
          attrs: { draggable: "" },
          on: {
            dragstart: function($event) {
              return _vm.onDragStart(element.field)
            },
            dragenter: function($event) {
              $event.preventDefault()
            },
            dragover: function($event) {
              $event.preventDefault()
            },
            drop: function($event) {
              return _vm.onDrop(element.field)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "table-header__title",
              on: {
                click: function() {
                  return _vm.sortClickHandler(element)
                }
              }
            },
            [
              _vm._v("\n      " + _vm._s(element.title) + "\n      "),
              element.sortable &&
              _vm.sortDirection &&
              _vm.orderBy === element.field
                ? _c("div", {
                    class: _vm.sortIconClass,
                    domProps: { innerHTML: _vm._s(_vm.arrowIcon) }
                  })
                : element.sortable
                ? _c("div", {
                    staticClass: "icon",
                    domProps: { innerHTML: _vm._s(_vm.updown) }
                  })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          element.filterable
            ? _c("div", { staticClass: "table-header__filter" }, [
                _c("input", {
                  on: {
                    change: function(val) {
                      return _vm.filterChangeHandler(element, val)
                    },
                    input: function(val) {
                      return _vm.filterChangeHandler(element, val)
                    }
                  }
                })
              ])
            : _vm._e()
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }